const SNOW = Array.from({ length: 26 }, (_, i) => ({
  left: (i * 37) % 100,
  size: 2 + (i % 3),
  duration: 9 + (i % 7),
  delay: (i * 1.37) % 10,
  drift: ((i % 5) - 2) * 16,
  opacity: 0.22 + (i % 4) * 0.12,
}));

export const Snowfall = () => (
  <div aria-hidden className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
    {SNOW.map((flake, i) => (
      <span
        key={i}
        className="snowflake"
        style={{
          left: `${flake.left}%`,
          width: flake.size,
          height: flake.size,
          opacity: flake.opacity,
          animationDuration: `${flake.duration}s`,
          animationDelay: `-${flake.delay}s`,
          "--drift": `${flake.drift}px`,
        }}
      />
    ))}
  </div>
);

const STARS = Array.from({ length: 32 }, (_, i) => ({
  left: (i * 29 + 7) % 100,
  top: (i * 17 + 5) % 70,
  size: 1.5 + (i % 3),
  delay: (i * 0.43) % 3,
  duration: 2.2 + (i % 4) * 0.7,
}));

export const TwinkleStars = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    {STARS.map((star, i) => (
      <span
        key={i}
        className="absolute rounded-full bg-amber-100 animate-[twinkle_3s_ease-in-out_infinite]"
        style={{
          left: `${star.left}%`,
          top: `${star.top}%`,
          width: star.size,
          height: star.size,
          animationDelay: `${star.delay}s`,
          animationDuration: `${star.duration}s`,
          boxShadow: "0 0 6px rgba(243,229,171,0.8)",
        }}
      />
    ))}
  </div>
);
